import { TransactionV2 } from "@bn/api/apiv1";

export const filterTransactionsByPurposeAndInvestmentName = (
  transactions: TransactionV2[],
  text: string = ""
): TransactionV2[] => {
  if (!text) return transactions;
  if (!transactions.length) return [];

  const loweredText = text.toLowerCase();

  return transactions.filter(({ isAdjustingEntry, purpose, booking }) => {
    const investmentName = booking?.investment.name;
    if (isAdjustingEntry) return true;

    if (!purpose && !investmentName) return false;

    return (
      purpose?.toLowerCase().includes(loweredText) ||
      investmentName?.toLowerCase().includes(loweredText)
    );
  });
};
